__turbopack_context__.v({
  "activeConfigBlock": "registry-visualization-module__tWZ6bG__activeConfigBlock",
  "activeGridItem": "registry-visualization-module__tWZ6bG__activeGridItem",
  "arrowLeft": "registry-visualization-module__tWZ6bG__arrowLeft",
  "arrowRight": "registry-visualization-module__tWZ6bG__arrowRight",
  "backgroundCanvas": "registry-visualization-module__tWZ6bG__backgroundCanvas",
  "brandTitle": "registry-visualization-module__tWZ6bG__brandTitle",
  "centerLabel": "registry-visualization-module__tWZ6bG__centerLabel",
  "centerSection": "registry-visualization-module__tWZ6bG__centerSection",
  "configBlock": "registry-visualization-module__tWZ6bG__configBlock",
  "configCore": "registry-visualization-module__tWZ6bG__configCore",
  "featureCallouts": "registry-visualization-module__tWZ6bG__featureCallouts",
  "featureIndicator": "registry-visualization-module__tWZ6bG__featureIndicator",
  "featureTag": "registry-visualization-module__tWZ6bG__featureTag",
  "float": "registry-visualization-module__tWZ6bG__float",
  "flowConnector": "registry-visualization-module__tWZ6bG__flowConnector",
  "flowIcon": "registry-visualization-module__tWZ6bG__flowIcon",
  "flowIndicator": "registry-visualization-module__tWZ6bG__flowIndicator",
  "glowingBackground": "registry-visualization-module__tWZ6bG__glowingBackground",
  "gridItem": "registry-visualization-module__tWZ6bG__gridItem",
  "gridItemInner": "registry-visualization-module__tWZ6bG__gridItemInner",
  "icon": "registry-visualization-module__tWZ6bG__icon",
  "iconContainer": "registry-visualization-module__tWZ6bG__iconContainer",
  "iconGroup": "registry-visualization-module__tWZ6bG__iconGroup",
  "iconIndicator": "registry-visualization-module__tWZ6bG__iconIndicator",
  "incomingConfig": "registry-visualization-module__tWZ6bG__incomingConfig",
  "leftFlowConnector": "registry-visualization-module__tWZ6bG__leftFlowConnector",
  "leftSection": "registry-visualization-module__tWZ6bG__leftSection",
  "logo-pulse": "registry-visualization-module__tWZ6bG__logo-pulse",
  "outgoingConfig": "registry-visualization-module__tWZ6bG__outgoingConfig",
  "particleStream": "registry-visualization-module__tWZ6bG__particleStream",
  "primaryArrow": "registry-visualization-module__tWZ6bG__primaryArrow",
  "primaryItem": "registry-visualization-module__tWZ6bG__primaryItem",
  "provider-pulse": "registry-visualization-module__tWZ6bG__provider-pulse",
  "providerLogo": "registry-visualization-module__tWZ6bG__providerLogo",
  "pulse": "registry-visualization-module__tWZ6bG__pulse",
  "pulse-portal": "registry-visualization-module__tWZ6bG__pulse-portal",
  "pulse-portal-easing": "registry-visualization-module__tWZ6bG__pulse-portal-easing",
  "quaternaryArrow": "registry-visualization-module__tWZ6bG__quaternaryArrow",
  "quaternaryCore": "registry-visualization-module__tWZ6bG__quaternaryCore",
  "quaternaryIndicator": "registry-visualization-module__tWZ6bG__quaternaryIndicator",
  "quaternaryItem": "registry-visualization-module__tWZ6bG__quaternaryItem",
  "registry": "registry-visualization-module__tWZ6bG__registry",
  "registryBase": "registry-visualization-module__tWZ6bG__registryBase",
  "registryGrid": "registry-visualization-module__tWZ6bG__registryGrid",
  "registryHeader": "registry-visualization-module__tWZ6bG__registryHeader",
  "registryIndicator": "registry-visualization-module__tWZ6bG__registryIndicator",
  "registryPortal": "registry-visualization-module__tWZ6bG__registryPortal",
  "registryWrapper": "registry-visualization-module__tWZ6bG__registryWrapper",
  "registryWrapperContainer": "registry-visualization-module__tWZ6bG__registryWrapperContainer",
  "rightConfig": "registry-visualization-module__tWZ6bG__rightConfig",
  "rightFlowConnector": "registry-visualization-module__tWZ6bG__rightFlowConnector",
  "rightSection": "registry-visualization-module__tWZ6bG__rightSection",
  "searchArea": "registry-visualization-module__tWZ6bG__searchArea",
  "secondaryArrow": "registry-visualization-module__tWZ6bG__secondaryArrow",
  "secondaryCore": "registry-visualization-module__tWZ6bG__secondaryCore",
  "secondaryIndicator": "registry-visualization-module__tWZ6bG__secondaryIndicator",
  "secondaryItem": "registry-visualization-module__tWZ6bG__secondaryItem",
  "sectionLabel": "registry-visualization-module__tWZ6bG__sectionLabel",
  "secure-pulse": "registry-visualization-module__tWZ6bG__secure-pulse",
  "sideSection": "registry-visualization-module__tWZ6bG__sideSection",
  "tertiaryArrow": "registry-visualization-module__tWZ6bG__tertiaryArrow",
  "tertiaryCore": "registry-visualization-module__tWZ6bG__tertiaryCore",
  "tertiaryIndicator": "registry-visualization-module__tWZ6bG__tertiaryIndicator",
  "tertiaryItem": "registry-visualization-module__tWZ6bG__tertiaryItem",
  "verifiedBadge": "registry-visualization-module__tWZ6bG__verifiedBadge",
  "visualizationContainer": "registry-visualization-module__tWZ6bG__visualizationContainer",
});
